import type { SgBootstrapTheme } from '@sgwt/sgwt-widgets-react';
import { ofType } from 'redux-observable';
import { merge } from 'rxjs';
import { ignoreElements, map, take, tap } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { updateTheme } from 'utils/theming';

interface AccountCenterThemeSwitcher extends Element {
  changeTheme(theme: SgBootstrapTheme): void;
}

export function updateThemeEpic(): SpEpic {
  return action$ => {
    const firstUserPreferencesReceived$ = action$.pipe(ofType('USER_PREFERENCES_RECEIVED'), take(1));
    const userPreferencesDarkModeChanged$ = action$.pipe(ofType('USER_PREFERENCES_DARK_MODE_CHANGED'));

    return merge(
      firstUserPreferencesReceived$.pipe(map(({ data }) => data.isDarkMode)),
      userPreferencesDarkModeChanged$.pipe(map(({ value }) => value)),
    ).pipe(
      tap(isDarkMode => {
        const variation = window.SGWTWidgetConfiguration.context.getSgDesignSystemTheme();
        const hasThemeChanged = isDarkMode !== (variation === 'dark');
        if (hasThemeChanged) {
          const accountCenter = document.querySelector<AccountCenterThemeSwitcher>('sgwt-account-center');
          if (typeof accountCenter?.changeTheme === 'undefined') {
            accountCenter?.addEventListener(
              'sgwt-account-center--ready',
              () => {
                accountCenter?.changeTheme(isDarkMode ? 'dark' : 'standard');
              },
              { once: true },
            );
          } else {
            accountCenter?.changeTheme(isDarkMode ? 'dark' : 'standard');
          }
          updateTheme(isDarkMode ? 'dark' : 'standard');
        }
      }),
      ignoreElements(),
    );
  };
}
